import ActionSheet from './action-sheet';
import open from './open';
import './styles/index.scss';
const ExpandedActionSheet = ActionSheet;
ExpandedActionSheet.show = open;
export default ExpandedActionSheet;
